import { StoryblokComponent } from '@storyblok/react'
import { type ContentBlokStoryblok } from '#types/component-types-sb'

const ContentBlok = ({ blok }: ContentBlokStoryblok) => {
	return <StoryblokComponent blok={blok} />
}
export default ContentBlok
